import { useState, useEffect } from 'react';

/**
 * Hook pour gérer le restaurant sélectionné avec persistance dans localStorage
 * Permet de conserver le choix du restaurant lors de la navigation entre pages
 */
export const useSelectedRestaurant = () => {
  const STORAGE_KEY = 'stratos_selected_restaurant';
  
  // Récupérer le restaurant sauvegardé ou '39v' par défaut
  const getSavedRestaurant = (): string => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      return saved || '39v';
    } catch (error) {
      console.warn('Erreur lecture localStorage:', error);
      return '39v';
    }
  };

  const [selectedRestaurant, setSelectedRestaurantState] = useState<string>(getSavedRestaurant);

  // Fonction wrapper qui sauvegarde dans localStorage
  const setSelectedRestaurant = (restaurantId: string) => {
    try {
      localStorage.setItem(STORAGE_KEY, restaurantId);
      setSelectedRestaurantState(restaurantId);
    } catch (error) {
      console.warn('Erreur écriture localStorage:', error);
      setSelectedRestaurantState(restaurantId);
    }
  };

  // Synchroniser avec les autres onglets/fenêtres
  useEffect(() => {
    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === STORAGE_KEY && e.newValue) {
        setSelectedRestaurantState(e.newValue);
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  return {
    selectedRestaurant,
    setSelectedRestaurant,
    clearSelection: () => {
      localStorage.removeItem(STORAGE_KEY);
      setSelectedRestaurantState('39v');
    }
  };
};

